/** 
 * Product carousels – Splide.js
 * Used in section/related-products.liquid, section/collection-carouse.liquid
 */ 
document.addEventListener( 'DOMContentLoaded', function () {
  let typeLg, typeMd, typeSm, typeXs, arrowsLg, arrowsMd, arrowsSm, arrowsXs;

  function initVariables () {
    typeLg = 'slide';
    typeMd = 'slide';
    typeSm = 'slide';
    typeXs = 'slide';
    arrowsLg = false;
    arrowsMd = false;
    arrowsSm = false;
    arrowsXs = false;
  }

  // Eanable loop only when there are more products to show
  function showCarousel (productNum, splideItem) {
    if (productNum > 1) {
      typeXs = 'loop';
      arrowsXs = true;
    }
    
    if (productNum > 2) {
      typeSm = 'loop';
      arrowsSm = true;
    }
    
    if (productNum > 3) {
      typeMd = 'loop';
      arrowsMd = true;
    }
    
    if (productNum > 4) {
      typeLg = 'loop';
      arrowsLg = true;
    }

    new Splide(splideItem, {
      type: typeLg,
      arrows: arrowsLg,
      perPage: 4,
      gap: '2rem',
      breakpoints: {
        1100: {
          perPage: 3,
          type: typeMd,
          arrows: arrowsMd,
        },
        767: {
          perPage: 2,
          type: typeSm,
          arrows: arrowsSm,
        },
        640: {
          perPage: 1,
          type: typeXs,
          arrows: arrowsXs,
        },
      },
      pagination: false,
    }).mount();
  }

  // Collection Carousel – All Products Page / Service Pages
  const collections = document.querySelectorAll('.collection-carousel');

  for (i = 0; i < collections.length; i++) {
    initVariables();
    const productNum = parseInt(collections[i].querySelectorAll('.splide__slide').length);
    showCarousel(productNum, collections[i]);
  }

  // Related Product Carousel – Product Page
  initVariables();
  const relatedProducts = document.querySelectorAll('#splide-related .splide__slide').length;

  if (relatedProducts > 1) {
    showCarousel(relatedProducts, '#splide-related');
  }
});
